<template>
    <v-card>
        <v-card-subtitle class="d-flex mx-2">
            <v-chip small label v-bind:color="getChipColor(order.status)">{{
                order.status
            }}</v-chip>
            <span class="ml-auto my-auto">ID: {{ order.id }}</span>
        </v-card-subtitle>
        <v-divider />
        <template v-if="order.orderable.restaurant">
            <v-card-title>{{ order.orderable.restaurant.name }}</v-card-title>
            <v-card-subtitle v-if="order.orderable.restaurant.location">
                {{ order.orderable.restaurant.location.name }}
            </v-card-subtitle>
        </template>
        <v-card-text class="d-flex align-center">
            <v-icon small class="mr-1">mdi-clock</v-icon>
            {{ new Date(order.created_at) | date('dd-MMM-yyyy p') }}
        </v-card-text>
        <v-divider />
        <v-card-text>
            <p class="mb-2">Customer:</p>
            <span class="text-h6 text--primary d-flex align-center">
                <v-icon class="mr-1">mdi-account</v-icon>
                {{ order.customer_name }}
            </span>
            <span class="d-flex align-center">
                <v-icon small class="ml-1 mr-2">mdi-phone</v-icon>
                {{ order.customer_phone }}
            </span>
            <span
                v-if="order.orderable.destination"
                class="d-flex align-center"
            >
                <v-icon small class="ml-1 mr-2">mdi-map-marker</v-icon>
                {{ order.orderable.destination.name }}
            </span>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <p class="mb-2">Courier:</p>
            <template v-if="order.courierinfo && order.courierinfo.user">
                <span class="text--primary d-flex align-center">
                    <v-icon small class="ml-1 mr-2">mdi-motorbike</v-icon>
                    {{ order.courierinfo.user.name }}
                </span>
                <span class="d-flex align-center">
                    <v-icon small class="ml-1 mr-2">mdi-phone</v-icon>
                    {{ order.courierinfo.user.phone }}
                </span>
            </template>
            <p v-else>(Not assigned)</p>
        </v-card-text>
        <v-divider />
        <v-card-text>
            <v-chip small label>{{ order.payment_type }}</v-chip>
            <span class="d-flex align-center mt-1">
                <strong>{{ getTotal() | currency }} (Total)</strong>
            </span>
            <small class="d-flex align-center mt-1">
                <template v-if="order.orderable.amount">
                    {{ order.orderable.amount | currency }} (Restaurant amount)
                </template>
                <template v-else>
                    (Restaurant amount not set)
                </template>
            </small>
            <small class="d-flex align-center mt-1">
                <template v-if="order.service_charge">
                    {{ order.service_charge | currency }} (Service charge)
                </template>
                <template v-else>
                    (Service charge not set)
                </template>
            </small>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn icon v-on:click="$emit('request-show', order)">
                <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn icon v-on:click="$emit('request-edit', order)">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon v-on:click="$emit('request-delete', order)">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import statusUtil from '@/utils/statusUtil';

export default {
    props: {
        order: {
            type: Object,
            require: true
        }
    },
    methods: {
        getChipColor(status) {
            return statusUtil.getOrderStatusColor(status);
        },
        getTotal() {
            if (null == this.order) {
                return 0;
            }
            return (
                Number(this.order.orderable.amount) +
                Number(this.order.service_charge)
            );
        }
    }
};
</script>
